export const EquipmentGetInfoSuccess = 'EQUIPMENT_GET_INFO_SUCCESS';
export const EquipmentDetailsSuccess = 'EQUIPMENT_GET_DETAILS_SUCCESS';
export const InviteMemberSuccess = 'INVITE_MEMBER_SUCCESS';
export const GetEquipmentFilterSuccess = 'GET_EQUIPMENT_FILTER_SUCCESS';
export const GetPrimaryFieldSuccess = 'GET_PRIMARY_FIELD_SUCCESS';
export const GetInvoiceListSuccess = 'GET_INVOICE_LIST_SUCCESS';

export function setEquipmentFilterInfoAction(data) {
  return {
    type: EquipmentGetInfoSuccess,
    payload: data,
  };
}

export function setEquipmentCustomerDetailsAction(data) {
  return {
    type: EquipmentDetailsSuccess,
    payload: data,
  };
}

export function setInviteMemberAction(data) {
  return {
    type: InviteMemberSuccess,
    payload: data,
  };
}

export function setEquipmentFilterAction(data) {
  return {
    type: GetEquipmentFilterSuccess,
    payload: data,
  };
}

export function setPrimaryFieldsAction(data) {
  return {
    type: GetPrimaryFieldSuccess,
    payload: data,
  };
}

export function setInvoiceListAction(data) {
  return {
    type: GetInvoiceListSuccess,
    payload: data,
  };
}
